import React from 'react'
import Cash from "../../New_Web_design/Cash.png";
import logo_img from "../../New_Web_design/W_Logo.png";
import service_icons from "../../New_Web_design/service_icons.png";
import secure_img from "../../New_Web_design/secure_img.png";
import instant_img from "../../New_Web_design/instant_img.png";
import img_24_7 from "../../New_Web_design/24_7_img.png";

export default function Banner() {
  return (
    <div>
      {" "}
      <div className="liner-last">
        <div
          style={{
            width: "100%",
            display: "flex",
            height: "auto",
            justifyContent: "center",
            marginTop: "70px",
          }}
        >
          {" "}
          <div
            className="mt-5 sub-bold-italic-font-width "
            style={{
              height: "100%",
              width: "60%",
              position: "relative",
            }}
          >
            <div
              className="item"
              style={{ display: "flex", justifyContent: "center" }}
            >
              <img
                src={logo_img}
                style={{ height: "100%", width: "60%", objectFit: "cover" }}
              />
            </div>
            <img
              className=""
              src={Cash}
              style={{
                height: "100%",
                width: "100%",
                objectFit: "cover",
              }}
            />
          </div>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
          }}
          className="mt-3"
        >
          <p
            className="text-liner bold-italic-font text-center"
            style={{ fontFamily: "JosefinSansItalic" }}
          >
            {/* <span style={{ fontFamily: "NunitoBoldItalic" }}>WolfWin </span>
Your Skills, Your Worth, Your Winnings!
            <span style={{ fontFamily: "JosefinSansItalic" }}>
              Play Games to Win
            </span> */}
            Your Skills, Your Worth, Your Winnings!
          </p>
        </div>
        <div
          className="container sub-bold-italic-font-width"
          style={{ width: "50%" }}
        >
          <h1
            style={{
              color: "white",
              fontFamily: "NunitoBoldItalic",
              fontWeight: "900",
              color: "white",
            }}
            className="line sub-bold-italic-font mt-3"
          >
            WolfWin
          </h1>
        </div>
      </div>
      <div className="container mt-5 logo_imgs my-5" id="About">
        <img src={service_icons} height="100%" width="100%" />
        {/* <div className="row py-5">
          <div
            className="col-3  "
            style={{ display: "flex", justifyContent: "center" }}
          >
            <div
              style={{
                height: "125px",
                width: "125px",
              }}
              className="logos"
            >
              <img
                src={No_bots_img}
                style={{
                  height: "100%",
                  width: "100%",
                  objectFit: "contain",
                }}
              />
            </div>
          </div>
          <div
            className="col-3  "
            style={{ display: "flex", justifyContent: "center" }}
          >
            <div style={{ height: "125px", width: "125px" }} className="logos">
              <img
                src={secure_img}
                style={{
                  height: "100%",
                  width: "100%",
                  objectFit: "contain",
                }}
              />
            </div>
          </div>
          <div className="col-3 ">
            <div style={{ height: "125px", width: "165px" }} className="logos">
              <img
                src={instant_img}
                style={{
                  height: "100%",
                  width: "100%",
                }}
              />
            </div>
          </div>
          <div
            className="col-3  "
            style={{ display: "flex", justifyContent: "center" }}
          >
            <div style={{ height: "125px", width: "125px" }} className="logos">
              <img
                src={img_24_7}
                style={{
                  height: "100%",
                  width: "100%",
                  objectFit: "contain",
                }}
              />
            </div>
          </div>
        </div> */}
      </div>
    </div>
  );
}
